import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api/api.service';
import {
    LoadByFollow,
    LoadByFollowFail,
    LoadByFollowSuccess,
    ProductArrivalActionTypes,
} from '@core/actions/product-arrival.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class ProductArrivalEffects {

  @Effect()
  loadByFollow$: Observable<Action> = this.actions$.pipe(
    ofType<LoadByFollow>(ProductArrivalActionTypes.LoadByFollow),
    map(action => [
      action.FollowId,
      action.CountryId,
      action.ProformaId,
      action.ProductId
    ]),
    switchMap(([followId, countryId, proformaId, ProductId]) =>
      this.api
        .getProuctArrivalsByFollow(followId, countryId, proformaId, ProductId)
        .pipe(
          map(
            (arrivals: any) => new LoadByFollowSuccess(arrivals)
          ),
          catchError(error => of(new LoadByFollowFail(error)))
        )
    )
  );

  constructor(
    private actions$: Actions,
    private api: ApiService,
  ) {}
}
